<div>
  <section class="header-title-dash" style="margin-top: 60px; margin-left: 0">
    {{''|i18n:title}}
  </section>
  <h5 style="color: orange;margin-bottom: 30px; margin-left: 6%;">{{''| i18n:'warranty-estimation-disclaimer'}}</h5>
  @if (displaySellingDealer) {
    <section id="sellingDealerSection">
      <div style="align-content: space-between"><label>{{''|i18n:'select-selling-dealer'}}:</label></div>
      <select class="col-2" [(ngModel)]="selectedSellingDealerNumber">
        @for (dealer of sellingDealers; track dealer) {
          <option
          [value]=dealer.dealerNumber>{{dealer.dealerName}}</option>
        }
      </select>
    </section>
  }
  @if (selectedSellingDealerNumber && displayStartUpButtons) {
    <section id="startUpButtonsSection"
      class="filter-item-btn-creation">
      <button class="button-estimation"
        (click)="onContractTypeChange('premium')">{{'' | i18n: 'warranty-contract-for-cars'}}
        <br/><span>{{'' | i18n: ''}}</span></button>
        <button class="button-estimation"
          (click)="onContractTypeChange('motorrad')">{{'' | i18n: 'warranty-contract-for-bikes'}}
          <br/><span>{{'' | i18n: ''}}</span></button>
        </section>
      }
      @if (displayCarButtons) {
        <section id="carButtonsSection">
          <button [class]="buttonClass('premium')"
            (click)="onContractTypeChange('premium')">{{'' | i18n: 'BMW PREMIUM SELECTION/MINI NEXT'}}
            <br/><span>{{'' | i18n: 'labeled-car-contract-estimate'}}</span></button>
            <button [class]="buttonClass('support')"
              (click)="onContractTypeChange('support')">{{'' | i18n: 'BMW SUPPORT/MINI SUPPORT'}}
              <br/><span>{{'' | i18n: 'used-car-contract-estimate'}}</span></button>
              <button [class]="buttonClass('euro-plus')"
                (click)="onContractTypeChange('euro-plus')">{{'' | i18n: 'BMW EUROPlus/ BMWi EuroPlus/ Mini EuroPlus'}}
                <br/><span>{{'' | i18n: 'extended-warranty-contract-estimate'}}</span></button>
              </section>
            }
            @if (displayMotorradButtons) {
              <section id="motorradButtonsSection">
                <button class="button-estimation_selected">{{'' | i18n: 'BMW MOTORRAD PREMIUM SELECTION'}}
                  <br/><span>{{'' | i18n: 'labeled-bike-contract-estimate'}}</span></button>
                </section>
              }
              @if (displayEstimationDetails && this.selectedSellingDealerNumber) {
                <app-estimation-details [displayOrderAndDeliveryDates]="displayOrderAndDeliveryDates"
                  [displayMileage]="displayMileage"
                  [dealerNumber]="selectedSellingDealerNumber"
                  [contractTypes]="selectedContractTypes"
                  [selectVehicleDetailsMethod]="isSelectedContractTypeEuroplus"
                ></app-estimation-details>
              }


            </div>
